/* 🤖 this file was generated by svg-to-ts */
export const matIconMobileFriendly: {
  name: 'mobile-friendly';
  data: string;
} = {
  name: 'mobile-friendly',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"/></svg>`
};
